import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SEO from '../components/SEO';
import './PrivacyPolicy.css';

const API_BASE = 'https://api.sofiasurgicals.com';

const PrivacyPolicy = () => {
    const [policy, setPolicy] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const fetchPolicy = async () => {
            setLoading(true);
            setError(null);
            try {
                const res = await axios.get(`${API_BASE}/api/get-PrivacyPolicy`);
                if (!res.data.status) {
                    setError('Privacy Policy is currently unavailable.');
                    setPolicy(null);
                } else {
                    setPolicy(res.data);
                }
            } catch (err) {
                console.error('Failed to fetch Privacy Policy:', err);
                setError('Privacy Policy not found.');
            } finally {
                setLoading(false);
            }
        };

        fetchPolicy();
    }, []);

    if (loading) {
        return (
            <div className="privacy-policy-section">
                <SEO
                    title="Privacy Policy"
                    description="Read Sofia Surgicals' Privacy Policy to understand how we collect, use, and protect your personal information."
                    url="/PrivacyPolicy"
                />
                <p>Loading Privacy Policy...</p>
            </div>
        );
    }

    if (error || !policy) {
        return (
            <div className="privacy-policy-section">
                <SEO
                    title="Privacy Policy"
                    description="Read Sofia Surgicals' Privacy Policy."
                    url="/PrivacyPolicy"
                />
                <p>{error || 'Privacy Policy not found.'}</p>
            </div>
        );
    }

    return (
        <div className="privacy-policy-section">
            <SEO
                title="Privacy Policy"
                description="Read Sofia Surgicals' Privacy Policy to understand how we collect, use, and protect your personal information."
                url="/PrivacyPolicy"
            />

            <div className="privacy-policy-content">
                <div
                    dangerouslySetInnerHTML={{ __html: policy.policy }}
                />
            </div>
        </div>
    );
};

export default PrivacyPolicy;